export default __webpack_public_path__ + "static/media/poster.9a36fda3.jpg";